(function () {
  'use strict';
  if (window.bcjNativeCartShippingLoaded) return;
  window.bcjNativeCartShippingLoaded = true;

  var plans = new Set(['9632678195', '9629368627']);
  var handles = new Set(['elk-mesquite-meat-sticks', 'jalapeno-cheese-meat-stick',
    'teriyaki-meat-stick', 'hickory-venison-meat-sticks', 'peppered-beef-jerky',
    'jalapeno-honey-meat-sticks', 'original-meat-stick', 'habanero-heat-jerky',
    'sweet-heat-jerky', 'honey-bbq-jerky', 'teriyaki-pork-jerky', 'hickory-bbq-jerky',
    'original-beef-jerky', 'beefcake-jalapeno-cheese-beef-bites']);
  var messages;
  var observed = new WeakSet();

  function fromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    if (cart.items.some(function (item) {
      return !item || typeof item.requires_shipping !== 'boolean' || !Number.isSafeInteger(Number(item.quantity)) || Number(item.quantity) < 1;
    })) return null;
    var state = { total: cart.total_price, currency: cart.currency, country: window.Shopify && window.Shopify.country,
      count: cart.item_count, physical: 0,
      nonphysical: 0, standard: 0, unknown: 0, onetime: 0, messages: messages };
    cart.items.forEach(function (item) {
      var quantity = Number(item.quantity);
      if (!Number.isSafeInteger(quantity) || quantity < 1) return;
      if (item.requires_shipping !== true) { state.nonphysical += quantity; return; }
      state.physical += quantity;
      var allocation = item.selling_plan_allocation;
      var plan = allocation && allocation.selling_plan && String(allocation.selling_plan.id);
      if (item.parent_relationship || item.has_components || (item.properties && item.properties._dynamicBoxId)) state.unknown += quantity;
      else if (!allocation) state.onetime += quantity;
      else if (plans.has(plan) && handles.has(item.handle) && !item.has_components &&
        !(item.properties && item.properties._dynamicBoxId)) state.standard += quantity;
      else state.unknown += quantity;
    });
    return state;
  }

  function shippingView(state) {
    if (!state || !state.messages) return null;
    var copy = state.messages;
    var view = { visible: state.physical > 0, text: copy.generic, progress: null, done: false };
    if (!view.visible || state.unknown || state.nonphysical || state.currency !== 'USD' || state.country !== 'US') return view;
    if (state.standard) {
      view.text = state.onetime ? copy.mixed : copy.subscription;
      view.done = true;
      return view;
    }
    if (!Number.isSafeInteger(state.total) || state.total < 0) return view;
    var remaining = Math.max(14999 - state.total, 0);
    view.progress = Math.min(state.total / 14999 * 100, 100);
    view.done = remaining === 0;
    view.text = remaining ? copy.remaining.replace('__amount__', new Intl.NumberFormat(
      document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(remaining / 100)) : copy.unlocked;
    return view;
  }

  function paint(state) {
    var view = shippingView(state);
    if (!view) return;
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (currency && currency !== state.currency) { view.text = state.messages.generic; view.progress = null; view.done = false; }
    document.querySelectorAll('[data-bcj-shipping]').forEach(function (meter) {
      meter.hidden = !view.visible;
      meter.classList.toggle('bcj-cart__ship--done', view.done);
      var text = meter.querySelector('[data-bcj-shipping-message]');
      var track = meter.querySelector('[data-bcj-shipping-track]');
      var fill = meter.querySelector('[data-bcj-shipping-fill]');
      if (text) text.textContent = view.text;
      if (track) track.hidden = view.progress === null || view.done;
      if (fill) fill.style.width = (view.progress || 0) + '%';
    });
    document.querySelectorAll('[data-bcj-page-shipping-trust]').forEach(function (label) {
      label.textContent = view.text;
      label.closest('.bcj-cart__trust-row').hidden = !view.visible;
    });
    document.querySelectorAll('[data-bcj-cart-tax-note]').forEach(function (label) {
      label.textContent = view.visible ? state.messages.shipping_taxes : state.messages.taxes;
    });
    var count = document.querySelector('[data-bcj-page-count]');
    if (count && Number.isSafeInteger(state.count)) count.textContent = state.count + (state.count === 1 ? ' item' : ' items');
  }

  function readState(node) {
    if (!node) return null;
    try {
      var state = JSON.parse(node.getAttribute('data-bcj-shipping-state'));
      if (state && state.messages) messages = state.messages;
      return state;
    } catch (_) { return null; }
  }

  function connect() {
    var initial = document.querySelector('[data-bcj-shipping-state]');
    if (initial) paint(readState(initial));
    document.querySelectorAll('#CartPageForm [data-products], #CartDrawer [data-products]').forEach(function (container) {
      if (observed.has(container)) return;
      observed.add(container);
      new MutationObserver(function () {
        paint(readState(container.querySelector('[data-bcj-shipping-state]')));
      }).observe(container, { childList: true, subtree: true });
    });
  }

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    paint(fromCart(cart));
  });
  document.addEventListener('page:loaded', connect);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect);
  else connect();
})();
